import "./StockListComponent.scss";
import SearchComponent from "../../../../shared/components/search/SearchComponent";
import React, {useCallback, useEffect, useState} from "react";
import {CommonService} from "../../../../shared/services";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../../store/reducers";
import StockListTableComponent from "./stock-list-table/StockListTableComponent";

interface StockListComponentProps {
    productId: any;
    onModeChange: Function;
}

const StockListComponent = (props: StockListComponentProps) => {
    const {productId,onModeChange} = props;

    const {queryParamData} = useSelector((state: IRootReducerState) => state.stateManagement);

    const [filterData, setFilterData] = useState<any>({
        search: '',
        orderId: productId
    });

    const handleSearch = useCallback((value: string) => {
        setFilterData((prevState: any) => ({
            ...prevState,
            search: value
        }));
        CommonService.setQueryParam('search', value);
    }, []);

    useEffect(() => {
        if (queryParamData) {
            setFilterData((prevState: any) => ({
                ...prevState,
                search: queryParamData.search || '',
            }));
        }
    }, [queryParamData]);

    useEffect(() => {
        onModeChange('view')
    }, [onModeChange]);


    return (
        <div className={'stock-list-component'}>
            <div className="page-data-wrapper">
                <div className="page-options">
                    <div className="page-search">
                        <SearchComponent
                            label={"Search Sample"}
                            id="search_input"
                            placeholder={""}
                            value={filterData.search}
                            onChange={handleSearch}
                        />
                    </div>
                    <div className="page-extra-options">
                        {/*{commonService.checkAccess('TestOrder', 'testOrderResultCorrection', currentUser?.userAccessModules) &&*/}
                        {/*    <ButtonComponent*/}
                        {/*        type="button"*/}
                        {/*        color={"secondary"}*/}
                        {/*        variant={"outlined"}*/}
                        {/*        startIcon={<RestorePageIcon/>}*/}
                        {/*        disabled={testPanelList.length === 0}*/}
                        {/*        handleClick={() => {*/}
                        {/*            showUploadUpdatesResultDialogOpen(true);*/}
                        {/*        }}*/}
                        {/*    >*/}
                        {/*        Result Correction*/}
                        {/*    </ButtonComponent>*/}
                        {/*}*/}
                    </div>
                </div>
                <div className="">
                    <StockListTableComponent filterData={filterData}/>
                </div>
            </div>
        </div>
    );

};

export default StockListComponent;
